import React from 'react';
import { Link } from '@reach/router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const MenuItem = ({
  item,
  selectedMenu,
  selectedSubMenu,
  isSubMenuOpen,
  hasAccess,
  handleNavToggle,
  setSelectedMenu,
  setSelectedSubMenu,
}) => {
  const {
    key,
    icon,
    title,
    route,
    subItems,
    accessKey,
  } = item;

  // Check if this menu item has access
  const hasMenuAccess = () => {
    if (subItems && subItems.length > 0) {
      // For parent menu items, check if any sub-item has access
      return subItems.some((subItem) => hasAccess(subItem.accessKey));
    }
    return hasAccess(accessKey);
  };

  if (!hasMenuAccess()) {
    return null;
  }

  // Render simple menu item (no submenus)
  if (!subItems || subItems.length === 0) {
    const getRoute = () => {
      if (item.conditionalRoute && item.fallbackRoute) {
        return hasAccess(accessKey) ? route : item.fallbackRoute;
      }
      return route;
    };

    return (
      <li className="nav-item">
        <Link
          to={getRoute()}
          className="nav-item"
          onClick={() => handleNavToggle(key)}
        >
          <div className={`nav-link ${selectedMenu === key ? 'active' : ''}`}>
            <span className="nav-icon">
              <FontAwesomeIcon icon={icon} />
            </span>
            {title}
          </div>
        </Link>
      </li>
    );
  }

  // Render menu item with submenus
  const getActiveClass = () => {
    const isParentActive = selectedMenu === key || isSubMenuOpen;
    const hasActiveSubMenu = subItems.some((subItem) => selectedSubMenu === subItem.key);
    return `nav-link ${isParentActive ? 'show' : ''} ${hasActiveSubMenu ? 'active' : ''}`;
  };

  return (
    <li
      className="nav-item"
      onClick={() => handleNavToggle(key)}
    >
      <div className={getActiveClass()}>
        <span className="nav-icon">
          <FontAwesomeIcon icon={icon} />
        </span>
        {title}
        <ul className={`sub-nav shadow nav flex-column ${isSubMenuOpen ? 'show' : ''}`}>
          <li className="nav-item">
            <div className="back-arrow d-flex align-items-center mb-2" type="button" onClick={() => handleNavToggle('back')}>
              <span className="px-2">
                <FontAwesomeIcon icon={faArrowLeft} />
              </span>
              <h4 className="mb-0">{title}</h4>
            </div>
            {subItems.map((subItem) => {
              if (!hasAccess(subItem.accessKey)) {
                return null;
              }
              return (
                <Link
                  key={subItem.key}
                  to={subItem.route}
                  className={`nav-link ${selectedSubMenu === subItem.key ? 'active' : ''}`}
                  onClick={() => {
                    setSelectedSubMenu(subItem.key);
                    setSelectedMenu(key);
                  }}
                >
                  {subItem.title}
                </Link>
              );
            })}
          </li>
        </ul>
      </div>
    </li>
  );
};

export default MenuItem;
